const translation: Record<string, string> = {
  siteName: '穿搭换装指南',
  home: '首页',
  about: '关于我们',
  contact: '联系我们',
  readMore: '阅读更多',
  backHome: '回到首页',
};

export default translation;